<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modal__backdrop" @click="closeModal()"/>
      <div class="modal__dialog">
        <div class="modal__content">
          <slot name="body"/>
        </div>
        <i class="modal__close fa fa-times position-absolute" @click="closeModal()"></i>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ModalMedia",
  data() {
    return {
      show: false
    };
  },
  methods: {
    closeModal() {
      this.show = false;
      document.querySelector("body").classList.remove("overflow-hidden");
    },
    openModal() {
      this.show = true;
      document.querySelector("body").classList.add("overflow-hidden");
    }
  }
};
</script>


<style lang="scss">
.modal {
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  display: block;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  &__backdrop {
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1003;
  }
  &__dialog {
    background-color: white;
    border-radius: 10px;
    position: fixed;
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    transform: translate(-50%, -50%);
    z-index: 1004;
    box-shadow: 0 5px 15px rgb(0 0 0 / 50%);

    @media screen and (max-width: 992px) {
      width: 90%;
    }
  }

  &__close {
    display:inline-block;
    margin: 10px;
    top: 5px;
    right: 5px;
    cursor: pointer;
    color: #666666;
    font-size: 18px;
  }

  &__body {
    overflow: auto;
    display: flex;
    flex-direction: row;
    align-items: stretch;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>